<template>
  <div class="is-pc">
    <div class="swiper login-swiper">
      <div class="swiper-wrapper">
        <!-- <div class="swiper-slide"><img src="@/assets/images/image1.jpg" /></div> -->
        <div v-for="banner in bannersPc" :key="banner.bnnrSn" class="swiper-slide">
          <img :src="banner.bannerImageUrl" />
        </div>
      </div>
      <div v-if="bannersPc && bannersPc.length >= 2" class="c-swiper-buttons">
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev">
          <span class="sr-only">이전 슬라이드</span>
          <i class="c-icon icon-arrow size-small"></i>
        </div>
        <div class="swiper-button-next">
          <span class="sr-only">다음 슬라이드</span>
          <i class="c-icon icon-arrow size-small"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="is-mo">
    <div class="swiper login-swiper">
      <div class="swiper-wrapper">
        <!-- <div class="swiper-slide"><img src="@/assets/images/image1.jpg" /></div> -->
        <div v-for="banner in bannersMo" :key="banner.bnnrSn" class="swiper-slide">
          <img :src="banner.bannerImageUrl" />
        </div>
      </div>
      <div v-if="bannersMo && bannersMo.length >= 2" class="c-swiper-buttons">
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev">
          <span class="sr-only">이전 슬라이드</span>
          <i class="c-icon icon-arrow size-small"></i>
        </div>
        <div class="swiper-button-next">
          <span class="sr-only">다음 슬라이드</span>
          <i class="c-icon icon-arrow size-small"></i>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup name="mainSwiper">
import { inject, onMounted, ref } from "vue";
// Import Swiper Vue.js components
import Swiper, { Pagination, Navigation, Autoplay } from "swiper";
import { api } from "@/plugins/api";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const url = inject("url_prefix");

const swiperInstance = ref(null);
const bannersPc = ref([]);
const bannersMo = ref([]);

onMounted(async () => {
  await loadBanners();
  await initSwiperPc();
  await initSwiperMo();
});

const loadBanners = async () => {
  const res = await api.get(`${url}/common/banner/selectLoginBannerList`);

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: loginSwiper.loadBanners] `);
    return;
  }

  const pc = [];
  const mo = [];

  res.data.forEach((item) => {
    const banner = {
      ...item,
      bannerImageUrl: FILE_CDN_URL + item.imgFilePath + "/" + item.imgFileNm,
    };

    if (item.dvcPcYn === "Y") {
      pc.push(banner);
    } else {
      mo.push(banner);
    }
  });

  bannersPc.value = pc;
  bannersMo.value = mo;

  // await initializeSwiper().then(initSwiper());
};

// const initializeSwiper = async () => {
//   return new Promise((resolve) => {
//     if (document.readyState === "complete") {
//       resolve(); // DOM이 이미 로드된 경우 즉시 resolve
//     } else {
//       document.addEventListener("DOMContentLoaded", () => {
//         resolve(); // DOMContentLoaded 이벤트 발생시 resolve
//       });
//     }
//   });
// };

/**********************
 * 스와이퍼 호출
 *********************/
 const initSwiperPc = async () => {
  const swiperElement = document.querySelector(".is-pc .login-swiper");
  if (swiperElement) {
    swiperInstance.value = new Swiper(swiperElement, {
      modules: [Pagination, Navigation, Autoplay],
      speed: 400,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 40,
      autoplay: {
        delay: bannersPc.value.length > 1 ? 2000 : 99999000,
      },
      navigation: {
        nextEl: ".login-swiper .swiper-button-next",
        prevEl: ".login-swiper .swiper-button-prev",
      },
      pagination: {
        el: ".login-swiper .swiper-pagination",
        type: "fraction",
        renderFraction: (currentClass, totalClass) => {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
    });
  }
};
const initSwiperMo = async () => {
  const swiperElement = document.querySelector(".is-mo .login-swiper");
  if (swiperElement) {
    swiperInstance.value = new Swiper(swiperElement, {
      modules: [Pagination, Navigation, Autoplay],
      speed: 400,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 40,
      autoplay: {
        delay: bannersMo.value.length > 1 ? 2000 : 99999000,
      },
      navigation: {
        nextEl: ".login-swiper .swiper-button-next",
        prevEl: ".login-swiper .swiper-button-prev",
      },
      pagination: {
        el: ".login-swiper .swiper-pagination",
        type: "fraction",
        renderFraction: (currentClass, totalClass) => {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
    });
  }
};
</script>
